import template from './session-editor.directive.html';

export const sessionEditorDirective = () => {
	return {
		restrict: 'E',
		require: {
			formController: '^form',
			ngModelController: 'ngModel'
		},
		scope: {
			session: '=ngModel',
			currentMode: '=mode',
			user: '=',
			users: '=?',
			group: '=',
			activity: '=',
			options: '=',
			onStimulusSaved: '&'
		},
		template,
		controller: 'SessionEditorController',
		controllerAs: 'editController',
		bindToController: true
	};
};
